import cx from 'classnames';
import styles from './NaviTableHeader.module.scss';
import { useNaviTableContext } from '../../context/NaviTableContext';
import NaviTableHeaderRow from './NaviTableHeaderRow';
import { RowData } from '@tanstack/react-table';
import { NaviTableVariants } from '../../interfaces';

const NaviTableHeader = <TData extends RowData>() => {
  const naviTableProps = useNaviTableContext<TData>();
  const {
    variant = NaviTableVariants.DEFAULT,
    table,
    headerClasses,
    headerTopCoordinate = 0,
    headerLineRef,
    headerRef,
    isScrolled = false,
    sizeColumnsToFit = true
  } = naviTableProps;

  const isCardVariant = variant === NaviTableVariants.CARDS;

  return (
    <>
      <div className="w-full" ref={headerLineRef} />
      <div
        className={cx(
          styles.naviTableHeaderContainer,
          {
            [styles.naviTableHeaderScrolled]: isScrolled,
            [styles.naviTableHeaderVariantCards]: isCardVariant,
            [styles.naviTableHeaderVariantDefault]: !isCardVariant
          },
          headerClasses
        )}
        style={{ top: headerTopCoordinate }}
        ref={headerRef}
      >
        <div style={{ width: !sizeColumnsToFit ? table.getTotalSize() : '100%' }}>
          {table.getHeaderGroups().map(headerGroup => (
            <NaviTableHeaderRow key={headerGroup.id} headerGroup={headerGroup} />
          ))}
        </div>
      </div>
    </>
  );
};

export default NaviTableHeader;
